import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { getAllCourseForStudent } from "../services/getAllCourseForStudent";
import { components } from "react-select";
import { CustomControlSearch } from "./CustomSelect/CustomSelect";


 const CustomOption = (props) => {
  const { data } = props;
  return (
    <components.Option {...props}>
      <div style={{ textAlign: "left", lineHeight: "1.3" }}>
        <div
          style={{
            fontWeight: 500,
            fontSize: "15px",
            color: "#212529",
          }}
        >
          {data?.fullItem?.courseName}
        </div>

        {data?.fullItem?.university?.universityName && (
          <div
            style={{
              fontSize: "12px",
              color: "#6c757d",
              marginTop: "2px",
            }}
          >
            {data.fullItem.university.universityName}
          </div>
        )}
      </div>
    </components.Option>
  );
};
const ExamPreparationSearch = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTerm.length > 2) {
        fetchSearchResults();
      } else {
        setOptions([]);
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const fetchSearchResults = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await getAllCourseForStudent(searchTerm);
      if (response?.isSuccess && response.data.length > 0) {
        const formattedOptions = response.data.map((item) => ({
          value: item._id,
          label: item.courseName,
          fullItem: item,
        }));
        setOptions(formattedOptions);
      } else {
        setOptions([]);
      }
    } catch (error) {
      setOptions([]);
    } finally {
      setIsLoading(false);
    }
  }, [searchTerm]);

  const handleSelectChange = (selectedOption) => {    
    if (selectedOption) {
      // Redirect to course details or home page
      navigate(
        `/course/${selectedOption?.fullItem?.university?.universityUrl}/${selectedOption.fullItem?.courseUrl}`,
        {
          state: { courseDetails: selectedOption.fullItem },
        }
      );
    }
  };

   const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "8px",
      padding: "4px",
      display: "flex",
      alignItems: "center",
    }),
    input: (provided) => ({
      ...provided,
      fontSize: "16px",
      border: "none",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#007bff" : "white",
      color: state.isSelected ? "white" : "black",
      ":hover": {
        backgroundColor: state.isSelected ? "#007bff" : "#f1f1f1",
      },
      fontSize: "16px",
      textAlign: "left",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: "16px",
    }),
  };



  return (
    <Select
      isSearchable
      isClearable
      isLoading={isLoading}
      placeholder="Search for courses..."
      onInputChange={(newValue) => setSearchTerm(newValue)}
      options={options}
      onChange={handleSelectChange}
      styles={customStyles}
    //  components={{ Option: CustomOption }}
     components={{ Control: CustomControlSearch }}
      noOptionsMessage={() =>
        searchTerm.length > 2 ? "No courses found" : "Start typing to search"
      }
    />
  );
};

export {CustomOption}
export default ExamPreparationSearch;
